/** @jsxImportSource @emotion/react */
import { skipToken } from '@reduxjs/toolkit/query'
import moment from 'moment'
import { useGetBillingChargeQuery } from 'store/services/billingCharges'

// Read-only Insurance Notes of the order the selected charge was created from.
// Shares the charge details query the posting forms already make.
export const OrderInsuranceNotes = ({
  patientId,
  chargeId,
  compact = false,
}: {
  patientId?: number | string
  chargeId?: string
  // Sized like the inline apply row's compact fields.
  compact?: boolean
}) => {
  const { currentData: charge } = useGetBillingChargeQuery(
    patientId && chargeId ? { id: chargeId, patientId: String(patientId) } : skipToken,
  )
  const data = charge?.insuranceNotes

  if (!chargeId || !data?.notes) {
    return null
  }

  const metaCss = compact ? { fontSize: '0.75rem' } : undefined

  return (
    <div className="mt-2" data-testid="order-insurance-notes">
      <div className="d-flex align-items-baseline" css={{ gap: 8 }}>
        <span
          className={compact ? 'textGray' : undefined}
          css={compact ? { fontWeight: 700, fontSize: '0.75rem' } : { fontWeight: 600, fontSize: 14 }}>
          Insurance Notes
        </span>
        {data.time && (
          <small className="text-muted" css={metaCss}>{moment(data.time).format('MM/DD/YYYY h:mm a')}</small>
        )}
        {data.followUpDate && (
          <small className="text-muted" css={metaCss}>Follow-up {moment(data.followUpDate).format('MM/DD/YYYY')}</small>
        )}
      </div>
      <div
        className={`${compact ? '' : 'mt-1 p-2'} border rounded bg-white font-italic`}
        css={{
          whiteSpace: 'pre-wrap',
          maxHeight: 150,
          overflowY: 'auto',
          fontSize: 14,
          // Same box as the form-control-sm inputs of the inline row.
          ...(compact && {
            fontSize: '0.875rem',
            lineHeight: 1.5,
            padding: '0.25rem 0.5rem',
            minHeight: 'calc(1.5em + 0.5rem + 2px)',
          }),
        }}>
        {data.notes}
      </div>
    </div>
  )
}
